var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-label"},[_vm._t("default"),_vm._t("append",[(_vm.required)?_c('span',{staticClass:"error--text"},[_vm._v("*")]):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }